import React, { useEffect } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getUsers } from "reduxSlices/formBuilderSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskUserSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserSelector"
/* eslint-enable max-len */

const TaskMemberSelector = ({ className = "" }) => {
  const users = useSelector(getUsers)

  const { addMemberId, taskAssigneeIds, taskMemberIds } = useTaskFormContext()

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskMemberIds.length])

  const selectableUsers = users.reduce((userList, user) => {
    if (user.active && !taskMemberIds.includes(user.id)) {
      userList.push(
        {
          ...user,
          ...(taskAssigneeIds.includes(user.id) && { marker: "Assignee" }),
        },
      )
    }
    return userList
  }, [])

  return (
    <TaskUserSelector
      addUserId={addMemberId}
      className={className}
      taskUserType="Users"
      users={selectableUsers}
    />
  )
}

TaskMemberSelector.propTypes = {
  className: types.string,
}

export default TaskMemberSelector
